import React from 'react';
import PropTypes from 'prop-types';
import TextInfo, {
  TEXT_COLOR,
  TEXT_SIZE,
  TEXT_DECORATION,
  TEXT_DISPLAY,
} from '@/bit/components/components.text';
import { normalizePrice } from '@/utils/common';
import styles from './styles';
import {
  productPriceItemTypes as productPriceItemTypesAux,
  colors,
  fontTypes,
  sizes,
  decorations,
} from './enums';

export const productPriceItemTypes = productPriceItemTypesAux;

function productPriceItem({
  name,
  price,
  info,
  priceQuote,
  priceCurrency,
  promoted,
  promotionText,
  promotionPrice,
  type,
  description,
  className,
  cyData,
  asterisk = '',
}) {
  return (
    <div className={className} data-cy={cyData}>
      {name && (
        <div className={`product-price--${type}`}>
          <div>
            <TextInfo
              className="text--space"
              text={name}
              color={colors[type].textName}
              fontType={fontTypes[type].textName}
              size={sizes[type].textName}
              cyData={`${cyData}__name`}
            />
          </div>
          <TextInfo
            text={`${normalizePrice(price, 2)}${priceCurrency || ''}${
              priceQuote ? `/${priceQuote}` : ''
            }${asterisk || ''}`}
            color={colors[type].textPrice}
            fontType={fontTypes[type].textPrice}
            size={sizes[type].textPrice}
            decoration={
              promoted ? decorations[type].textPrice : TEXT_DECORATION.NONE
            }
            cyData={`${cyData}__price`}
          />
        </div>
      )}
      {promoted && (
        <div className={`product-price-promoted--${type}`}>
          <div>
            <TextInfo
              className="text--space"
              text={promotionText}
              color={colors[type].textPromotion}
              fontType={fontTypes[type].textPromotion}
              size={sizes[type].textPromotion}
              cyData={`${cyData}__promotion`}
              display={TEXT_DISPLAY.INLINE}
            />
          </div>
          <TextInfo
            text={`${normalizePrice(promotionPrice, 2)}${priceCurrency || ''}${
              priceQuote ? `/${priceQuote}` : ''
            }`}
            color={colors[type].textPromotionPrice}
            size={sizes[type].textPromotionPrice}
            fontType={fontTypes[type].textPromotionPrice}
            cyData={`${cyData}__promotion-price`}
          />
        </div>
      )}
      {info && (
        <div className={`product-price-info--${type}`}>
          <TextInfo
            className="text--space"
            text={info}
            color={colors[type].textInfo}
            fontType={fontTypes[type].textInfo}
            size={sizes[type].textInfo}
            cyData={`${cyData}__info`}
            display={TEXT_DISPLAY.INLINE}
          />
        </div>
      )}
      {description && (
        <TextInfo
          className="product-price__description"
          text={description}
          color={TEXT_COLOR.GREY5}
          size={TEXT_SIZE.CAPTION2}
        />
      )}
      <style jsx>{styles}</style>
    </div>
  );
}
productPriceItem.propTypes = {
  name: PropTypes.string,
  price: PropTypes.number,
  maxPrice: PropTypes.number,
  info: PropTypes.string,
  promoted: PropTypes.bool,
  promotionText: PropTypes.string,
  promotionPrice: PropTypes.number,
  priceQuote: PropTypes.string,
  priceCurrency: PropTypes.string,
  cyData: PropTypes.string,
};

productPriceItem.defaultProps = {
  name: '',
  price: null,
  maxPrice: null,
  info: '',
  promoted: false,
  promotionText: '',
  promotionPrice: null,
  priceQuote: '',
  priceCurrency: '',
  cyData: '',
};
export default productPriceItem;
